import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more\"><path d=\"M350.573714 21.430857L247.149714 124.854857 634.148571 512 247.149714 899.145143l103.424 103.424L841.142857 512z\" fill=\"#C1C5C9\" p-id=\"4899\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol